/* hico thread rail — 一本の糸が糸巻きシェードへ収束する演出
   依存ライブラリなし / Shopify theme asset
   使い方: snippets/thread-rail.liquid から呼び出す（README参照） */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.threadReady === '1') return;
    root.dataset.threadReady = '1';

    var svg = root.querySelector('[data-thread-svg]');
    var path = root.querySelector('[data-thread-path]');
    var halo = root.querySelector('[data-thread-halo]');
    var bulb = root.querySelector('[data-thread-bulb]');
    if (!svg || !path) return;

    function num(name, dflt) {
      var v = parseFloat(root.getAttribute('data-' + name));
      return isNaN(v) ? dflt : v;
    }

    var opt = {
      scope: root.getAttribute('data-scope') || 'main',            // スクロール量の基準要素
      gutter: root.getAttribute('data-gutter-probe') || '',        // 本文左端の基準要素（任意）
      turns: num('turns', 100),                                    // 巻き数
      points: num('points', 3000),                                 // 分割数（描画の細かさ）
      color: root.getAttribute('data-color') || '185,154,99',      // 糸（rgb）
      colorLit: root.getAttribute('data-color-lit') || '230,187,122',
      opacity: num('opacity', 72) / 100,                           // 糸の最大不透明度
      morphStart: num('morph-start', 12) / 100,                    // 巻き取り開始（スクロール%）
      morphEnd: num('morph-end', 82) / 100,                        // 完成（スクロール%）
      litStart: num('lit-start', 90) / 100,                        // 点灯位置（スクロール%）
      litRange: Math.max(1, num('lit-range', 9)) / 100,            // 点灯にかける幅
      size: num('size', 34) / 100,                                 // 球の半径（列幅比）
      wave: num('wave', 85) / 100,                                 // 途中の波の強さ
      minWidth: num('min-width', 900),
      spTurns: num('sp-turns', 42),
      spPoints: num('sp-points', 1100)
    };

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var box = null, raf = null, sig = '';

    function scopeEl() { return document.querySelector(opt.scope) || document.body; }

    function measure() {
      if (window.innerWidth < opt.minWidth) { root.style.opacity = '0'; return false; }
      var probe = opt.gutter ? document.querySelector(opt.gutter) : null;
      if (probe) {
        var avail = Math.max(0, probe.getBoundingClientRect().left - 14);
        root.style.width = avail + 'px';
        root.style.opacity = avail < 74 ? '0' : '1';
        if (avail < 74) return false;
      } else {
        root.style.opacity = '1';
      }
      var w = Math.max(svg.clientWidth, 60);
      var h = Math.max(svg.clientHeight, 400);
      var s = w + ':' + h;
      if (s !== sig) { sig = s; svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h); }
      box = { w: w, h: h };
      return true;
    }

    function mix(a, b, k) {
      return a.map(function (v, i) { return Math.round(v + (b[i] - v) * k); }).join(',');
    }

    function draw() {
      if (!box && !measure()) return;
      if (!box) return;
      var scope = scopeEl();
      var max = Math.max(scope.offsetHeight - window.innerHeight, 1);
      var p = Math.max(0, Math.min(1, window.scrollY / max));
      var span = Math.max(0.05, opt.morphEnd - opt.morphStart);
      var t = reduced ? 1 : Math.max(0, Math.min(1, (p - opt.morphStart) / span));
      t = t * t * (3 - 2 * t);

      var sp = window.innerWidth < 900;
      var w = box.w, h = box.h;
      var cx = w * 0.5, cy = h * 0.5;
      var R = Math.min(w * opt.size, h * 0.14);
      var amp = Math.min(w * 0.34, w * 0.5 - 6);
      var N = Math.round(sp ? opt.spPoints : opt.points), cordN = Math.round(N * 0.05);
      var turns = sp ? opt.spTurns : opt.turns;
      var wave = Math.sin(Math.PI * Math.min(1, t / 0.92)) * opt.wave;
      var d = '';

      for (var i = 0; i <= N; i++) {
        var s2 = i / N;
        // 直線 →（中盤で少しだけ波）
        var lx = cx + amp * wave * Math.sin(s2 * Math.PI * 4.4 + 0.6) * (0.55 + 0.45 * Math.sin(s2 * 2.1));
        var ly = -h * 0.06 + s2 * h * 1.12;
        var bx, by;
        if (i <= cordN) {
          var k = i / cordN;
          bx = cx + (lx - cx) * (1 - k) * 0.2;
          by = -h * 0.06 + k * (cy - R + h * 0.06);
        } else {
          // 大円を回しながら重ねる＝糸巻きシェードの網目
          var u = (i - cordN) / (N - cordN);
          var ph = u * Math.PI * 2 * turns;
          var al = u * Math.PI * 9.2 + 0.4;
          var ct = Math.cos(0.78 + 0.68 * Math.sin(u * Math.PI * 7.1 + 1.1));
          bx = cx + R * (Math.cos(ph) * Math.cos(al) - Math.sin(ph) * Math.sin(al) * ct);
          by = cy + R * (Math.cos(ph) * Math.sin(al) + Math.sin(ph) * Math.cos(al) * ct) * 0.97;
        }
        var e = Math.max(0, Math.min(1, (t - 0.18 - s2 * 0.14) / 0.68));
        d += (i ? 'L' : 'M') + (lx + (bx - lx) * e).toFixed(1) + ',' + (ly + (by - ly) * e).toFixed(1);
      }

      var lit = Math.max(0, Math.min(1, (p - opt.litStart) / opt.litRange));
      lit = lit * lit * (3 - 2 * lit);

      path.setAttribute('d', d);
      path.setAttribute('stroke', 'rgb(' + mix(opt.color.split(',').map(Number), opt.colorLit.split(',').map(Number), lit) + ')');
      path.setAttribute('stroke-opacity', Math.min(1, opt.opacity * (0.6 + 0.4 * t) + 0.16 * lit).toFixed(2));
      if (halo) {
        halo.setAttribute('cx', cx.toFixed(1));
        halo.setAttribute('cy', cy.toFixed(1));
        halo.setAttribute('r', (R * (1.6 + 1.5 * lit)).toFixed(1));
        halo.setAttribute('opacity', (lit * 0.85).toFixed(2));
      }
      if (bulb) {
        bulb.setAttribute('cx', cx.toFixed(1));
        bulb.setAttribute('cy', cy.toFixed(1));
        bulb.setAttribute('r', (R * (0.12 + 0.1 * lit)).toFixed(1));
        bulb.setAttribute('opacity', (Math.max(0, t - 0.6) * 0.5 + lit * 0.5).toFixed(2));
      }
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; draw(); });
    }
    function onResize() { sig = ''; box = null; measure(); draw(); }

    measure();
    draw();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    // 画像遅延読み込みなどで高さが変わるケースに追従
    setInterval(function () { sig = ''; measure(); draw(); }, 1500);
  }

  function boot() {
    document.querySelectorAll('[data-thread-rail]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme Editor でセクションが差し替わった場合
  document.addEventListener('shopify:section:load', boot);
})();
